// @flow
import type { BasketItem, TestSchedule, Product, CompanyBranch } from "../../lib/Types";
import type { DropDownItem } from "../DropDown";

import React from "react";
import styled from "styled-components";
import Input from "../Input";
import { fetchJson } from "../../lib/Fetching";
import Button from "../Button";
import CompanyBranchDropDown from "../crm/CompanyBranchDropDown";
import { DefaultPaddedContainerNoShadow } from "./Theme";
import MatrixInput from "../testing/MatrixInput";
import SuiteCategoryPicker from "./SuiteCategoryPicker";
import _ from "underscore";

const Row = styled.div.attrs({ className: "row" })``;
const Column = styled.div.attrs({ className: "col-md-3" })``;
const FullColumn = styled.div.attrs({ className: "col-md-12" })``;
const Container = styled(DefaultPaddedContainerNoShadow)`
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
`;

type Props = {
  company_id: number,
  findProducts: object => void,
  onBranchChange: CompanyBranch => void,
  fixedBranch: ?boolean,
  selectedCompanyBranchId: number
};

type State = {
  productName: string,
  selectedCompanyBranchId: ?number,
  matrixId: ?number,
  suiteCategoryId: ?number,
  suiteName: string
  // products: Array<Product>,
};

export default class ProductsFilter extends React.Component<Props, State> {
  state = {
    productName: "",
    selectedCompanyBranchId: this.props.selectedCompanyBranchId,
    products: [],
    suiteCategoryId: null,
    suiteName: ""
  };

  componentWillMount() {
    this.debounceFindProducts = _.debounce(this.findProducts, 200);
  }

  componentDidMount() {
    if (this.props.selectedCompanyBranchId) {
      this.debounceFindProducts();
    }
  }

  findProducts = () => {
    if (!this.valid()) return false;

    const { company_id, selectedCompanyBranchId } = this.props;
    const { productName, productBarcode, matrixId, suiteCategoryId, suiteName } = this.state;

    this.props.findProducts({
      company_id,
      form: {
        with_schedules: false,
        product_name: productName,
        register_company_branch_ids: [selectedCompanyBranchId],
        matrix_id: matrixId,
        suite_category_id: suiteCategoryId,
        product_barcode: productBarcode,
        suite_name: suiteName
      }
    });
  };

  valid = () => this.errorMessages().length == 0;

  errorMessages = () => {
    const { selectedCompanyBranchId } = this.state;
    const errors = [];
    if (!selectedCompanyBranchId) errors.push("Please select a branch");
    return errors;
  };

  productChanged = (e: SyntheticInputEvent<>) => {
    this.setState({ productName: e.target.value }, this.debounceFindProducts);
  };

  barcodeChanged = (e: SyntheticInputEvent<>) => {
    this.setState({ productBarcode: e.target.value }, this.debounceFindProducts);
  };

  branchChanged = (companyBranch: CompanyBranch) => {
    this.setState({ selectedCompanyBranchId: companyBranch.id }, this.findProducts);
    const { onBranchChange } = this.props;
    if (onBranchChange) {
      onBranchChange(companyBranch);
    }
  };

  updateSuiteCategory = suiteCategoryId => {
    this.setState({ suiteCategoryId }, this.debounceFindProducts);
  };

  suiteNameChanged = (e: SyntheticInputEvent<>) => {
    this.setState({ suiteName: e.target.value }, this.debounceFindProducts);
  };

  renderErrorMessages = () => {
    return (
      <div>
        {this.errorMessages().map((message, i) => (
          <div
            key={i}
            className="alert alert-warning"
            style={{ marginTop: 20, marginBottom: 0 }}
          >
            {message}
          </div>
        ))}
      </div>
    );
  };

  render() {
    const { company_id, fixedBranch } = this.props;
    const { productName, selectedCompanyBranchId, productBarcode, suiteName } = this.state;
    return (
      <Container>
        <Row>
          <Column>
            <label>{I18n.t("product_name")}</label>
            <Input
              onPressEnter={this.findProducts}
              onChange={this.productChanged}
              value={productName}
              className="form-control"
              placeholder={I18n.t("start_typing_to_filter_the_products_below")}
              autoFocus={true}
            />
          </Column>
          <Column>
            <label>{I18n.t("product_barcode")}</label>
            <Input
              onPressEnter={this.findProducts}
              onChange={this.barcodeChanged}
              value={productBarcode}
              className="form-control"
              selectAllOnFocus
            />
          </Column>
          {false && (
            <Column>
              <label>{I18n.t("register_at_branch")}</label>
              <CompanyBranchDropDown
                company_id={company_id}
                onBranchChange={() => {}}
                value={selectedCompanyBranchId}
                withProducts={true}
              />
            </Column>
          )}
          <Column>
            <label>{I18n.t("matrix")}</label>
            <MatrixInput
              multiple={false}
              onChange={option => {
                this.setState({ matrixId: option ? option.value : null }, this.findProducts);
              }}
              defaultStyle
            />
          </Column>
          <Column>
            <label>{I18n.t("suite")}</label>
            <Input
              onPressEnter={this.findProducts}
              onChange={this.suiteNameChanged}
              value={suiteName}
              className="form-control"
              placeholder={I18n.t("start_typing_to_filter_suites")}
            />
          </Column>
        </Row>
        {false && (
          <Row style={{ marginTop: 10 }}>
            <Column>
              <Button
                disabled={!this.valid()}
                icon="fa-search"
                title={I18n.t("view_products")}
                onClick={this.findProducts}
              />
            </Column>
          </Row>
        )}
        <Row>
          <FullColumn>
            <SuiteCategoryPicker
              company_id={company_id}
              onChange={id => this.updateSuiteCategory(id)}
            />
          </FullColumn>
        </Row>
        {this.renderErrorMessages()}
      </Container>
    );
  }
}
